import { useRef } from 'react';

export const useSemanticStableValue = <Value>(
	value: Value,
	isEnabled: boolean,
	areEqual: (current: Value, next: Value) => boolean,
): Value => {
	const stableValueRef = useRef(value);

	if (!isEnabled) {
		stableValueRef.current = value;
		return value;
	}

	if (!areEqual(stableValueRef.current, value)) {
		stableValueRef.current = value;
	}

	return stableValueRef.current;
};
